import { LayerProps } from 'react-map-gl';

const dataLayer: LayerProps = {
  id: 'lieuucation-micromarket-label',
  type: 'symbol',
  filter: ['==', ['get', 'type'], 'lieuucation'],
  layout: {
    'text-size': ['interpolate', ['linear'], ['zoom'], 10, 8, 18, 16],
    'text-anchor': 'top',

    'text-font': ['Nunito SemiBold Regular', 'Arial Unicode MS Regular'],

    'text-field': ['get', 'name'],
    'text-padding': 3,
    'text-letter-spacing': 0.1,
    'text-max-width': 7
  },
  paint: {
    'text-halo-width': 1,
    'text-halo-color': 'hsla(0, 0%, 10%, 0.75)',
    'text-halo-blur': 1,
    'text-color': 'hsl(0, 0%, 85%)'
  }
};

export default dataLayer;
